module.exports = __webpack_public_path__ + "static/img/ket-renewal.4ea840e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/ket-renewal.jpg
// module id = 3JHQ
// module chunks = 0